@if (isLoadedInitialData) {
  <app-side-panel
    #sidePanel
    [table]="TABLES.VERIFY"
    [printOptionActions]="sidePanelPrintActions"
    [showFraud]="true"
    (onSyncOrder)="reSyncOrderClick($event, true)"
    (changeColorCoding)="changeColorCoding($event)"
    (changeColorCodingDisplay)="changeColorCodingDisplay($event)">
  </app-side-panel>

  <mat-drawer-container class="verify-screen" (backdropClick)="closeSidePanel(drawer)">
    <!-- <mat-drawer #drawer mode="over" position="end" class="assign-sidebar__position"> -->

    <!-- </mat-drawer> -->
    <mat-drawer-content>
      <div [ngClass]="loading ? 'disabledbtn' : ''" class="preview">
        <div class="verify-screen__title">{{ screenTitle }}</div>
        <div class="verify-screen__tabs">
          <pdq-tabs-group (onChange)="changeFilter($event)">
            <pdq-tab
              [value]="FilterTypes.ALL"
              [label]="
                useCursorPagination()
                  ? cappedAllLabel()
                  : getLabelAndCounterString(FilterTypes.LABEL_ALL, countAllOrders)
              "
              [loading]="useCursorPagination() && deliverCursorPagination.tabCountersLoading()"></pdq-tab>
            <pdq-tab
              [value]="FilterTypes.VERIFIED"
              [label]="
                useCursorPagination()
                  ? cappedVerifiedLabel()
                  : getLabelAndCounterString(FilterTypes.LABEL_VERIFIED, countValidatedOrders)
              "
              [loading]="useCursorPagination() && deliverCursorPagination.tabCountersLoading()"></pdq-tab>
            <pdq-tab
              [value]="FilterTypes.FIX"
              [label]="
                useCursorPagination()
                  ? cappedFixLabel()
                  : getLabelAndCounterString(FilterTypes.LABEL_FLAGGED, countFixOrders)
              "
              [loading]="useCursorPagination() && deliverCursorPagination.tabCountersLoading()"></pdq-tab>
          </pdq-tabs-group>
          <div class="verify-screen__overflow">
            <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook - Maintain pdq-tooltip and use instead mattooltip   -->
            @if (shopService.isManualSyncSupported) {
              <sync-orders></sync-orders>
            }
          </div>
        </div>
        <div class="verify-screen__tabs-lower">
          @if (COLUMN_OPTIONS && COLUMN_OPTIONS.length) {
            <div class="verify-screen__edit-columns">
              <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
              <mat-select
                #editcolumns
                class="table-columns-select"
                panelClass="pdq-mat-select--panel__multi"
                floatlLabel="never"
                [(ngModel)]="selectedColumns"
                (selectionChange)="toggleColumn()"
                [disableOptionCentering]="true"
                multiple
                matTooltipClass="pdq-mat-tooltip"
                [matTooltip]="'Edit columns'">
                <div class="pdq-mat-select--panel--header">
                  Showing {{ selectedColumns.length + '/' + COLUMN_OPTIONS.length }} columns
                </div>
                @for (column of COLUMN_OPTIONS; track column) {
                  <mat-option selected="selected" [value]="column.prop">
                    {{ column.name }}
                  </mat-option>
                }
              </mat-select>
            </div>
          }
          <div>
            <app-newui-search-autocomplete
              (searchResultsToTable)="onSearchToTable($event)"
              [table]="TABLES.VERIFY"
              [showDeletedOrders]="false">
            </app-newui-search-autocomplete>
          </div>
        </div>
        <div class="verify-table-container">
          <app-table
            hotKeyShortcut
            [relevantShortcuts]="keyboardShortcuts"
            [shortcutScope]="shortcutScope"
            [table]="TABLES.VERIFY"
            [rows]="temp"
            [columnsSettings]="columns"
            [rowsLoading]="loading"
            [rowActions]="rowActions"
            [groupActions]="groupActions"
            [perPageActiveOption]="ordersPerPage"
            [totalCountOrders]="totalCountOrders"
            [allPages]="allPages"
            [focusedRowId]="focusedOrderId"
            [activePage]="activePage"
            [totalPages]="totalPages"
            [paginationMode]="useCursorPagination() ? 'cursor' : 'offset'"
            [cursorRangeLabel]="deliverCursorPagination.rangeLabel()"
            [cursorHasNextPage]="deliverCursorPagination.hasNextPage()"
            [cursorHasPreviousPage]="deliverCursorPagination.hasPreviousPage()"
            [totalCountDisplay]="useCursorPagination() ? deliverCursorPagination.totalCountDisplay() : null"
            (cursorPageChange)="onCursorPageChange($event)"
            [printOptionActions]="tablePrintActions"
            [selected]="selectedOrders"
            [isSyncingOrders]="isSyncingOrders"
            [message]="chooseEmptyMessage()"
            [disableGroupActions]="disableGroupActions"
            [selectedValidOrders]="selectedValidOrders"
            (sort)="sortColumns($event)"
            (deleteOrder)="onDeleteOrder($event)"
            (reSyncOrder)="reSyncOrderClick($event)"
            (changeFilter)="onChangeTableFilter($event)"
            (changePerPage)="onChangeOrdersPerPage($event)"
            (changePage)="paginate($event)"
            (jumpToPage)="jumpToPage($event)"
            (onTableActivate)="onTableActivate($event)"
            (changeSelectedOrders)="onChangeSelectedOrders($event)"
            (reSyncSelectedOrder)="reSyncSelectedOrder()"
            (onBottomScrolled)="onBottomScrolled($event)"
            (manualVerifySelectedOrders)="onManualVerifySelectedOrders($event)"
            (deleteSelectedOrder)="deleteSelectedOrder()"
            (selectOrderGroupActions)="toSelectedOrderActions($event)"
            (exportSelectedOrders)="exportSelectedOrders($event)"
            (onBulkPrint)="onBulkPrint($event)"
            (splitOrder)="splitOrder($event)"
            (changeLocationSelectedOrders)="changeLocationSelectedOrders($event)"
            (editPackageOrders)="editPackageOrders()"
            (mergeOrders)="mergeOrders()"
            (addTagSelectedOrders)="addTagSelectedOrders()"
            (onBulkColorCodingApply)="bulkChangeColorCoding($event)"
            (changeColorCoding)="changeColorCoding($event)"></app-table>
        </div>
        @if (
          (useCursorPagination()
            ? deliverCursorPagination.tabCounters()?.validated?.count > 0
            : countValidatedOrders > 0) && !disableQuickflows
        ) {
          <preview-action-container
            [isBottomScrolled]="isBottomScrolled"
            [assignLoader]="assignLoader"
            [selectedValidOrders]="selectedValidOrders"
            [countValidatedOrders]="
              useCursorPagination() ? deliverCursorPagination.tabCounters()?.validated?.count : countValidatedOrders
            "
            (onSendOrdersToAssign)="sendOrdersToAssign()"
            [isOrdersUpdating]="isOrdersUpdating"></preview-action-container>
        }
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
} @else {
  <skeleton-workspace-page [titleText]="screenTitle"></skeleton-workspace-page>
}
